import Reveal from "../components/Reveal";
import { Lock, ShieldCheck, KeyRound, FileClock, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";

const POINTS = [
  {
    icon: Lock,
    title: "TLS 1.2+ in transit",
    body: "Every request between your browser and ClientDesk VA is encrypted with modern TLS.",
  },
  {
    icon: KeyRound,
    title: "Passwords hashed by Supabase Auth",
    body: "Your password is bcrypt-hashed and never stored in plaintext, ever.",
  },
  {
    icon: ShieldCheck,
    title: "Tenant isolation at the database",
    body: "Postgres Row-Level Security means your organization's rows stay in your organization.",
  },
  {
    icon: FileClock,
    title: "Audit logging",
    body: "Every mutating action is logged with the actor, timestamp and IP for security review.",
  },
  {
    icon: Trash2,
    title: "You can delete everything",
    body: "Account deletion is available from Settings → Account, and by writing to us. See the details.",
  },
];

export default function SecurityTrust() {
  return (
    <section data-testid="security-trust" className="py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl mb-14">
          <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
            Security & privacy
          </div>
          <h2 className="font-display font-extrabold text-[30px] sm:text-[40px] leading-[1.08] tracking-[-0.02em] text-[#1A2A3A] mb-4">
            Built to earn your trust in plain language.
          </h2>
          <p className="text-[16px] text-[#57534E] leading-relaxed">
            We don't claim things we can't prove. Here's exactly what we do —
            and where to find the details.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 60}>
              <div className="p-6 rounded-2xl border border-[#E8E2D9] bg-[#FAF7F2] h-full">
                <p.icon size={22} strokeWidth={1.6} className="text-[#E8712C] mb-4" />
                <h3 className="font-display font-bold text-[16px] text-[#1A2A3A] tracking-[-0.01em] mb-2">
                  {p.title}
                </h3>
                <p className="text-[13.5px] text-[#57534E] leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-10 flex flex-wrap gap-2 text-[14px]">
          <Link to="/privacy" className="px-4 py-2 rounded-full bg-white border border-[#E8E2D9] hover:border-[#E8712C]/40 text-[#1A2A3A]">Privacy Policy →</Link>
          <Link to="/terms" className="px-4 py-2 rounded-full bg-white border border-[#E8E2D9] hover:border-[#E8712C]/40 text-[#1A2A3A]">Terms of Service →</Link>
          <Link to="/data-deletion" className="px-4 py-2 rounded-full bg-white border border-[#E8E2D9] hover:border-[#E8712C]/40 text-[#1A2A3A]">Account deletion →</Link>
          <Link to="/contact" className="px-4 py-2 rounded-full bg-white border border-[#E8E2D9] hover:border-[#E8712C]/40 text-[#1A2A3A]">Contact support →</Link>
        </div>
      </div>
    </section>
  );
}
